// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadBelowObserver__container-fae570 {
  position: relative;
  top: -5px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/LoadBelowObserver/LoadBelowObserver.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  top: -5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoadBelowObserver__container-fae570`
};
module.exports = ___CSS_LOADER_EXPORT___;
